<template>
  <div class="competeAgeGroupList">
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 年龄段 -->
        <el-table-column prop="ageGroupName" :label="$t('lang.lab_competeAgeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 年龄限制 -->
        <el-table-column :label="$t('lang.lab_ageGroupLimit')" :sortable="'custom'">
          <template slot-scope="scope">
            {{ scope.row.ageLatelyLimit }}~{{ scope.row.ageEarlyLimit }}
          </template>
				</el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-suffix=":">
        <!-- 年龄段 -->
        <el-form-item prop="ageGroupName" :label="$t('lang.lab_competeAgeGroup')">
          <input style="display: none"/>
          <el-input v-model="form.ageGroupName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeAgeGroup')" maxlength="20"></el-input>
        </el-form-item>
        <!-- 年龄限制 -->
        <el-form-item prop="ageGroupLimit" :label="$t('lang.lab_ageGroupLimit')">
          <el-row>
            <el-col :span="10"><input style="display: none"/><el-input v-model="form.ageLatelyLimit" :placeholder="$t('lang.lab_ageGroupLimitStart')" maxlength="3" @input="keyAgeLow" ></el-input></el-col>
            <el-col :span="4"><div class="center-style"><span>——</span></div></el-col>
            <el-col :span="10"><input style="display: none"/><el-input v-model="form.ageEarlyLimit" :placeholder="$t('lang.lab_ageGroupLimitEnd')" maxlength="3" @input="keyAgeHigh" ></el-input></el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isTotal === 0">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:competeAgeGroupList
 *@Description:年龄段管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
export default {
  name: '',
  components: {},
  data() {
    // 年龄限制
    var ageGroupLimitCheck = (rule, value, callback) => {
     if (this.form.ageLatelyLimit === '' && this.form.ageLatelyLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_ageLatelyLimit')))
      } else if (this.form.ageLatelyLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_ageLatelyLimit')))
      } else if (Number(this.form.ageLatelyLimit) < 0) {
        callback(new Error(this.$i18n.t('lang.warning_ageEnrollMin')))
      } else if (this.form.ageEarlyLimit === '') {
        callback(new Error(this.$i18n.t('lang.warning_ageEarlyLimit')))
      } else if (Number(this.form.ageEarlyLimit) < Number(this.form.ageLatelyLimit)) {
        callback(new Error(this.$i18n.t('lang.warning_ageEnrollLowUp')))
      } else if (Number(this.form.ageEarlyLimit) > 120 || Number(this.form.ageLatelyLimit) > 120) {
        callback(new Error(this.$i18n.t('lang.warning_ageEnrollMax')))
      } else {
        callback()
      }
    }
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      /* 确定按钮可点击 */
      isDisabled_form: 0, // form数据
      isDisabled_ageGroupValues: 0, // 年龄限制
      /* 年龄段管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 年龄段管理详情(新建编辑)变量 */
      rules: {
        // teamEnrollLimit: [{ required: true, validator: teamEnrollLimitCheck, trigger: 'blur' }],
        ageGroupName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeAgeGroup'), trigger: 'blur' }],
        ageGroupLimit: [{ required: true, validator: ageGroupLimitCheck, trigger: 'change' }],
			},
			ageGroupValues: [], // 年龄限制开始结束时间的绑定值
      form: {
        id: '',
        ageGroupName: '',
				ageEarlyLimit: '',
				ageLatelyLimit: '',
      }, // 详细数据
    }
  },
  computed: {
    isTotal: function() {
      console.log('isDisabled:', this.isDisabled_form, this.isDisabled_ageGroupValues)
      return this.isDisabled_form + this.isDisabled_ageGroupValues
    }
	},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_form) {
          // 没变
          this.isDisabled_form = 0
        } else {
          // 变了
          this.isDisabled_form = 1
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 年龄下限 输入限制
    keyAgeLow() {
      // 仅保留数字
      this.form.ageLatelyLimit = this.form.ageLatelyLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.ageLatelyLimit.indexOf('.') < 0 && this.form.ageLatelyLimit !== '') { 
        this.form.ageLatelyLimit = parseFloat(this.form.ageLatelyLimit)
      }
    },
    // 年龄上限 输入限制
    keyAgeHigh() {
      // 仅保留数字
      this.form.ageEarlyLimit = this.form.ageEarlyLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.ageEarlyLimit.indexOf('.') < 0 && this.form.ageEarlyLimit !== '') { 
        this.form.ageEarlyLimit = parseFloat(this.form.ageEarlyLimit)
      }
    },
    // 获取年龄段管理列表数据
    getData() {
      this.$get(`/itemAge/itemAge?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag) { 
      if (flag) {
        this.pageNum = 1
      }
      this.$get(`/itemAge/itemAge?sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 新增
    onAdd() {
      console.log('onAdd')
			this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.ageGroupName = ''
      this.form.ageEarlyLimit = ''
      this.form.ageLatelyLimit = ''
			// this.ageGroupValues = [Date.now() - 8.64e7, Date.now() - 8.64e7]
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/itemAge/age/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.ageGroupName = data.ageGroupName
      this.form.ageEarlyLimit = data.ageEarlyLimit
      this.form.ageLatelyLimit = data.ageLatelyLimit
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData_form = JSON.stringify(this.form)
      // this.changeData()
      this.isShow = true
		},
    // 数据转换
    // changeData() {
    //   // 转换年龄限制
    //   this.ageGroupValues = []
    //   if (this.form.ageEarlyLimit && this.form.ageEarlyLimit !== null && this.form.ageLatelyLimit && this.form.ageLatelyLimit !== null) {
    //     this.ageGroupValues[0] = this.form.ageEarlyLimit 
    //     this.ageGroupValues[1] = this.form.ageLatelyLimit  
    //     this.$set(this.ageGroupValues, 0, this.form.ageEarlyLimit) 
    //     this.$set(this.ageGroupValues, 1, this.form.ageLatelyLimit)               
    //   }
      // this.saveData_ageGroupValues = JSON.stringify(this.ageGroupValues)
    // },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.ageEarlyLimit = parseInt(this.form.ageEarlyLimit)
          this.form.ageLatelyLimit = parseInt(this.form.ageLatelyLimit)
          // 报名时间
          // if (this.ageGroupValues != []) {
            // this.form.ageEarlyLimit = this.ageGroupValues[0]
            // this.form.ageLatelyLimit = this.ageGroupValues[1]
          // }
          let params = this.form
          this.$postJson('/itemAge/age', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新列表
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.ageGroupName = ''
      this.form.ageEarlyLimit = ''
      this.form.ageLatelyLimit = ''
			this.ageGroupValues = []
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.ageGroupName = ''
      this.form.ageEarlyLimit = ''
      this.form.ageLatelyLimit = ''
			this.ageGroupValues = []
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true)
    },
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
.competeAgeGroupList{
  .center-style{
    width: 100%;
    text-align: center;
    margin: 0 auto;
  }
  .tip-color{
    color: #718295;
    font-size: 12px;
  }
}
</style>
